import createCrudModule from '@/utils/createCrudModule'

export default createCrudModule({
  resource: 'paymentPrices',
  urlRoot: '/payment_prices'
})
